import type { ResourceProps } from '@refinedev/core'
import { i18n } from '../../shared/i18n'

export const settlementManagementResources: ResourceProps[] = [
  {
    name: 'settlement-management',
    meta: {
      label: i18n.t('navigation.settlementManagement.label'),
    },
  },
  {
    name: 'settlement-account',
    list: '/settlements/account',
    meta: {
      label: i18n.t('navigation.settlementManagement.settlementAccount'),
      parent: 'settlement-management',
    },
  },
  {
    name: 'settlement-history',
    list: '/settlements/history',
    show: '/settlements/history/:id',
    meta: {
      label: i18n.t('navigation.settlementManagement.settlementHistory'),
      parent: 'settlement-management',
    },
  },
]
